import { ReactNode } from 'react';
import { MARKS } from '@contentful/rich-text-types';
import { RenderMark } from '@contentful/rich-text-react-renderer';
/*
 *  Renders markup from contentful input
 */
export const renderMarkup: RenderMark = {
    [MARKS.BOLD]: (text: ReactNode) => <strong key={`${text}`}>{text}</strong>,
    [MARKS.ITALIC]: (text: ReactNode) => <em key={`${text}`}>{text}</em>
};

/*
 *  Determines if the link is external, returns TRUE if... true
 */
export function isExternalUri(str: string): boolean {
    return /^https?:\/\/(?!www\.zoopla\.co\.uk\/)/.test(str);
}
